// extracted by mini-css-extract-plugin
export default {"imageWrapper":"kN-z","twoColumnImage":"lN-z"};